import { HOME_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const homeTabRoute = createGlobalRoute({
  exact: true,
  name: 'hometab',
  path: HOME_PATH,
  layout: 'home',
});
